import svgConnect from "../../../../assets/imgs/socials/connects/tiktok.svg";
import svgNaoConectado from "../../../../assets/imgs/socials/notConnects/tiktok.svg";

import MyImage from "../../../myImage"

const MyIconTiktok = ({sx, connect}) =><MyImage src={connect ? svgConnect : svgNaoConectado} alt={'tiktok icon'} sx={sx} />

export default MyIconTiktok;
